$(document).ready(function () {
    var $cardCarousel = $('.card-carousel');
    if ($cardCarousel.length > 0) {
        $cardCarousel.slick({
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            adaptiveHeight: true
        });
        $cardCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slick-active').removeClass('finished-animation');
        });
        $cardCarousel.on('afterChange', function (event, slick, currentSlide) {
            $('.slick-active').addClass('finished-animation');
        });
    }

    //four col card carousel
    var $fourColCardCarousel = $(".card-carousel-four");
    if ($fourColCardCarousel.length > 0) {
        $fourColCardCarousel.each(function () {
            let numberOfSlides = $(this).children().length;
            $(this).slick({
                infinite: true,
                dots: numberOfSlides > 4,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000,
                adaptiveHeight: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                prevArrow: '<button type="button" class="slick-prev card-carousel-four_arrow"><i class="fa fa-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next card-carousel-four_arrow"><i class="fa fa-angle-right"></i></button>',
                dotsClass: 'card-carousel-four_dots',
                customPaging: function (slider, i) {
                    return '<a></a>';
                },
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            dots: numberOfSlides > 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: numberOfSlides > 2
                        }
                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            slidesToScroll: 1,
                            dots: numberOfSlides > 1
                        }
                    }
                ]
            });
        });
    }
});